export const MAX_NUMBER_OF_PROFILES = 5

export type IProfileSummary = {
  profiles: Array<IProfile>
  meta: IProfileSummaryMeta
}

export type IProfile = {
  id: number
  name?: string | null
  kidsProfile?: boolean
  avatarName?: AvatarName | null
  kidsProfileTypeId?: number | null
  locked?: boolean
  avatar?: string | null
}

export const AvatarName = {
  FOX: 'fox',
  RACOON: 'racoon',
  HAMSTER: 'hamster',
  MOOSE: 'moose',
  ZEBRA: 'zebra',
  RABBIT: 'rabbit',
} as const
export type AvatarName = (typeof AvatarName)[keyof typeof AvatarName]

export type IProfileSummaryMeta = {
  kidsModuleAvailable?: boolean
  remainingRegularProfiles?: number
  remainingKidsProfiles?: number
  kidsProfileTypes?: Array<IKidsProfileType>
}

export type IKidsProfileType = {
  id: number
  title?: string | null
}

export interface IRemoveProfile {
  id: number
  kidsProfile?: boolean
}

export interface ICreateProfile extends Pick<
  IProfile,
  'name' | 'avatarName' | 'kidsProfile' | 'kidsProfileTypeId'
> {}
